<template>
  <div>
    <div class="confirmOrderPage">
      <Head @go="toContactsList" />
      <Loading v-if="isShowLoading" />
      <section v-else class="contentWrap">
        <div class="cardBox" v-for="(item, index) in cartData" :key="index">
          <div class="titleBox" v-if="item.title">
            <van-row class="titleRow">
              <span class="title"><img src="../../../assets/images/handShake.png" class="iconImg" />{{ item.title }}</span>
            </van-row>
          </div>
          <div class="orderItemBox" v-for="(orderItem, itemIndex) in item.list" :key="itemIndex">
            <van-row class="orderIfnRow">
              <ConfirmOrderShopCard
                v-if="item.id === 'shopData'"
                :data="orderItem"
                :priceWeight="true"
                sign="shopSub"
                @changeMark="changeMark($event, index, itemIndex, orderItem)"
              />
            </van-row>
          </div>
        </div>
        <Discount v-if="isShowCoupon" @change="changeDiscount" :data="couponsListData" :selceted="selectedCoupon" />
        <van-row class="agreeBox fhlud">
          <p class="fvlw">
            <span class="checkboxSpan">
              <van-checkbox
                v-if="severPactionListData.length"
                v-model="isAll"
                @click="changeAll"
                icon-size="16px"
                shape="square"
                checked-color="#3088c5"
              ></van-checkbox>
            </span>
            <span>已阅读并同意签署</span>
          </p>
          <van-checkbox-group v-model="severPactionResult" ref="checkboxGroupRef">
            <p class="severPactionItem" v-for="(item, i) in severPactionListData" :key="i">
              <span class="checkboxSpan">
                <!---这层span不要删-->
                <van-checkbox :name="i" icon-size="16px" style="width:16px" shape="square" checked-color="#3088c5"></van-checkbox>
              </span>
              <span>
                <span>阅读并签署</span>
                <span class="severPaction" @click="viewContract(item)">《{{ item.notificationName }}》</span>
              </span>
            </p>
          </van-checkbox-group>
        </van-row>
      </section>

      <van-overlay :show="isShowLoad" z-index="10000">
        <div class="wrapper" @click.stop>
          <van-loading size="24px" vertical>数据提交中...</van-loading>
        </div>
      </van-overlay>
      <ContractServiceDeal :showPopUp="showPopUp" :datas="contractData" />
      <ContractUserDeal :showPopUp="showUserPopUp" :datas="contractData" />
    </div>

    <!-- 底部按钮 -->
    <van-row class="bottomWrap fvlr">
      <van-col span="16">
        <div class="priceBox fhlud">
          <span
            >&nbsp;&nbsp;&nbsp;&nbsp;零售价：&nbsp;<span class="themeRed">￥{{ orderAmount }}</span>
          </span>
          <span v-if="isShowCoupon"
            >优惠金额：<span class="themeRed">-￥{{ discountAmount }}</span>
          </span>
          <span
            >应付金额：<span class="price">￥{{ payAmount }}</span>
          </span>
        </div>
      </van-col>
      <van-col span="8">
        <div :class="['sub', isAgree ? '' : 'disableBtn']" @click="subOrder">
          去购买
        </div>
      </van-col>
    </van-row>
    <teleport to="#app">
      <SubmitOrder ref="showSubmitOrderPopUp" />
    </teleport>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, nextTick, ref, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ConfirmOrderShopCard from '@/components/directSales/ConfirmOrderCard'
import Head from '@/components/directSales/ConfirmOrderHead'
import Discount from '@/components/directSales/ConfirmOrderDiscount'
import ContractServiceDeal from '@/components/directSales/ContractServiceDeal'
import ContractUserDeal from '@/components/directSales/ContractUserDeal'
import { useStore } from 'vuex'
import {
  getConfirmOrderInfo,
  shopCreateOrder,
  bindOrderForCustomer,
  getEWOrderConfirmDetail,
  getEWOrderConfirmDetailByOTR,
  bindOTROrder
} from '@/api/directSales'
import { Toast } from 'vant'
import SubmitOrder from '@/components/order/SubmitOrder.vue'
import Loading from '@/components/common/Loading.vue'
import { showToast } from '@/util/couponCollection'
import _ from 'lodash'
import { setSession, getSession } from '@/util'
import useContractServiceDealFn from '@/hooks/directSales/useContractServiceDeal'
import moment from 'moment'
import { EWOrderTypeFlag } from '@/util/order/staticConfig'

export default {
  components: {
    Head,
    Loading,
    Discount,
    ContractServiceDeal,
    ContractUserDeal,
    ConfirmOrderShopCard,
    SubmitOrder
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const checkboxGroupRef = ref()
    let bugGooodsInfo = store.state.currentBuyProductInfo
    let loyaltyDealerInfo = store.state.loyaltyDealerInfo || {}
    let gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
    const {
      viewContractServiceDealFn,
      viewEWContractServiceDealFn,
      viewContractUserDealFn,
      showPopUp,
      contractData,
      showUserPopUp
    } = useContractServiceDealFn()
    const state = reactive({
      isShowCoupon: false,
      isShowServiceDealDetail: false,
      orderAmount: 0, //订单原价
      discountAmount: 0, //优惠金额
      payAmount: 0, //优惠后价格
      markData: {},
      couponsListData: [],
      selectedCoupon: {},
      severPactionData: [],
      severPactionResult: [],
      cartData: [],
      // isAgree: false,
      queryFrom: '',
      // {1:购物车入口请求,2:立即购买}
      typeFlag: '',
      orderNo: '',
      //支付方式标识{1:支付宝，2:微信}
      payMethodFlag: 1,
      subIng: false,
      isShowLoad: false,
      mobile: '',
      name: '',
      isAll: false,
      isAgree: false,
      userServicePactionData: [
        {
          type: 'userService',
          notificationName: '用户服务协议'
        }
      ],
      isShowLoading: false,
      categoryId: 0,
      orderTypeFlag: ''
    })
    const severPactionListData = computed(() => [...state.userServicePactionData, ...state.severPactionData])
    const showSubmitOrderPopUp = ref()
    const changeAll = () => {
      nextTick(() => {
        checkboxGroupRef.value.toggleAll(state.isAll)
      })
    }
    watch(
      () => store.state.currentContacts,
      v => {
        state.name = v?.currentUser?.name || ''
        state.mobile = v?.currentUser?.mobile || ''
      },
      { immediate: true, deep: true }
    )

    const viewContract = data => {
      if (!state.name) {
        showToast('联系人姓名缺失，请完善联系人信息')
        return
      }
      if (data.type === 'userService') {
        // showToast('- - 展示新的用户服务协议 - -')
        let option = { ...data, contactName: '哈利波特', sign: 'contractUser', title: '用户服务协议' }
        // console.log('viewContractUserDealFn-', option)
        viewContractUserDealFn(option)
        return
      }
      if (data.sign === 'ewProduct') {
        viewEWContractServiceDealFn(data)
        return
      }
      try {
        let option = { ...data, contactName: state.name }
        viewContractServiceDealFn(option)
      } catch (error) {
        showToast('数据有误')
      }
    }
    watch(
      () => state.severPactionResult,
      v => {
        let bool = v.length === severPactionListData.value?.length
        state.isAgree = bool
        state.isAll = bool
      },
      { immediate: true, deep: true }
    )

    // const isAgree = computed(() => state.severPactionResult.length === state.severPactionData.length)
    const toContactsList = path => {
      setSession('shopSelectedCoupon', state.selectedCoupon)
      setSession('shopMarkData', state.markData)
      path && router.push(path)
    }
    const changeMark = (value, index, itemIndex, data) => {
      console.log('changeMark--->', data, value, index, itemIndex)
      let productId = data.productId
      let key = `${index}-${itemIndex}-${productId}`
      let markData = _.cloneDeep(state.markData)
      markData[key] = value
      state.markData = { ...markData }
    }
    const changeDiscount = value => {
      console.log('changeDiscount--->', value)
      state.selectedCoupon = value
      setSession('shopSelectedCoupon', value)
      nextTick(() => {
        getPageDataFn()
      })
    }

    const getPageParam = () => {
      let productInfo = []

      // 来自商品详情
      let shopData = bugGooodsInfo?.shopData || {}
      if (route.query.from === 'shopDetail') {
        // {1:购物车入口请求,2:立即购买}
        state.typeFlag = 2
        productInfo = [
          {
            // devTemp
            // productId: '1544943930084544514',
            // gsCode: 'GS0003479',
            // customerCarId: '308',
            gsCode: shopData.gsCode, //gscode
            productId: shopData.productId, //产品id
            customerCarId: shopData.customerCarId, //车辆id
            productAmount: shopData.productAmount, //数量
            productType: shopData.productType //5服务合约6礼包
          }
        ]
      }
      // 来自购物车
      if (route.query.from === 'shoppingCarList') {
        // {1:购物车入口请求,2:立即购买}
        state.typeFlag = 1
        let shopData = bugGooodsInfo?.shopData || []
        productInfo = shopData.map(item => ({
          productAmount: item.num, //数量
          productId: item._data?.productId, //产品id
          productType: 5, //5服务合约6礼包
          gsCode: item.gsCode, //gscode
          customerCarId: item._data?.customerCarId, //车辆id
          cartId: item.id
        }))
      }
      let param = {}
      if (route.query.from === 'ewShopDetail' || route.query.from === 'ewShoppingCarList') {
        const ewProdduct = shopData.product
        param = {
          gsCode: ewProdduct.gsCode, //gscode
          skuId: ewProdduct.productId, //产品id
          customerCarId: ewProdduct.carInfo.id, //车辆id
          baumuster: ewProdduct.carInfo.baumuster,
          orderNo: shopData?.orderNo //订单号
        }
      } else {
        let { id: couponId = '', rightId = '' } = state.selectedCoupon
        param = {
          productInfo: productInfo,
          typeFlag: state.typeFlag,
          couponId, //券id（非必填）
          rightId, //券模板id（非必填）
          orderNo: shopData?.orderNo //订单号
        }
      }

      return param
    }

    const getPageData = async param => {
      let cartTempData = []
      let shopIdex = 0
      try {
        if (state.queryFrom === 'ewShoppingCarList' || state.queryFrom === 'ewShopDetail') {
          state.orderTypeFlag = EWOrderTypeFlag
          const data = param.orderNo ? await getEWOrderConfirmDetailByOTR(param.orderNo) : await getEWOrderConfirmDetail(param)
          state.categoryId = data.categoryId
          //延保只支持单独购买一个延保产品
          state.orderAmount = data.orderAmount ?? data.productAmount * data.retailPrice
          // coupon need to do
          state.couponsListData = []
          state.discountAmount = 0
          state.payAmount = data.payAmount ?? data.productAmount * data.retailPrice

          const isEwUsedCar = data.productType === 'PRD_CATEGORY_7'
          const notificationInfo = {
            fin: data.fin,
            contactName: state.name,
            day: moment().date(),
            month: moment().month() + 1,
            year: moment().year(),
            validPeriod: data.validPeriod,
            maxPurchaseMile: data.maxPurchaseMile,
            notificationFile: data.notificationPics,
            notificationName: data.notification,
            startDate: data.effectiveStartDate,
            endDate: data.validPeriod !== -1 && data.effectiveEndDate,
            sign: 'ewProduct',
            productType: data.productType
          }
          state.severPactionData = isEwUsedCar
            ? [
                {
                  ...notificationInfo,
                  maxPurchaseMile: data.maxPurchaseMile == -1 ? '不限制' : data.maxPurchaseMile,
                  exceedMileStart: '-',
                  sign: 'ewUsedCarProduct',
                  productType: data.productType
                }
              ]
            : [notificationInfo]
          cartTempData[shopIdex] = {
            title: '',
            id: 'shopData',
            list: [
              {
                ...data,
                thumbnail: data.thumbnail ?? data.productSpuThumbnail,
                productName: data.skuName,
                productNames: `${data.serviceContent};${data.serviceDuration}`,
                discounPrice: 0,
                productPrice: data.retailPrice,
                payPrice: data.payAmount,
                dealerInfo: {
                  name: data.gsName
                },
                carInfo: {
                  plate: data.plate,
                  model: data.model,
                  fin: data.fin,
                  vin: data.vin
                }
              }
            ]
          }

          return
        }
        let data = await getConfirmOrderInfo(param)
        let {
          products,
          coupons,
          notifications,
          order: { orderAmount, discountAmount, payAmount }
        } = data
        products = products.map((item, i) => ({ ...item, markText: state.markData[`${shopIdex}-${i}-${item.productId}`] }))
        cartTempData[shopIdex] = { title: '', id: 'shopData', list: products }
        let coupon = {
          dealerInfo: null,
          customerLoyaltyPlanId: null,
          activeEndTime: '2021-03-01 08:00:00',
          rightContent: {
            subtractPrice: 100,
            fullPrice: 1000
          },
          description: '权益描述',
          activeMonth: null,
          gsCode: 'GS0050651',
          rightTypeFlag: 1,
          customerId: '123',
          rightId: '207',
          statusName: '可使用',
          id: '42',
          useDescription: '使用说明',
          coupon: null,
          activeStartTime: '2021-02-01 08:00:00',
          activeTypeName: '有效期类型{1：按日期区间 2：按有效期}',
          updateTime: '2021-02-02 18:33:33',
          customerName: '系统管理员',
          sortValue: 1,
          rightName: '权益名称',
          activeTypeFlag: 1,
          createTime: '2021-02-02 18:33:33',
          couponCode: 'E75I550',
          customerMobile: '15888888888',
          usedNum: 0,
          statusFlag: 2
        }
        coupons = [coupon, { ...coupon, id: '222', rightContent: { subtractPrice: 12, fullPrice: 999 } }]
        state.orderAmount = orderAmount
        state.discountAmount = discountAmount
        state.payAmount = payAmount
        state.couponsListData = coupons
        state.severPactionData = notifications
      } catch (error) {
        state.cartData = []
        state.orderAmount = 0
        state.discountAmount = 0
        state.payAmount = 0
        state.couponsListData = []
        state.severPactionData = []
        console.error(error)
        showToast(error.message, '获取商品数据失败')
      } finally {
        state.cartData = cartTempData
        state.isAll = false
        state.isAgree = false
        state.isShowLoading = false
      }
    }

    const getPageDataFn = async () => {
      try {
        state.isShowLoading = true
        let param = getPageParam()
        await getPageData(param)
      } catch (error) {
        console.error(error)
      } finally {
        state.isShowLoading = false
      }
    }

    //获取延保的remark
    const getEWRemark = () => {
      const typeIndex = 0
      return state.cartData[typeIndex]?.list.map((item, itemIndex) => {
        const key = `${typeIndex}-${itemIndex}-${item.productId}`
        return state.markData[key] || ''
      })[0]
    }

    // 获取提交数据
    const getSubParam = () => {
      const { typeFlag, queryFrom } = state
      const bugGooodsInfo = store.state.currentBuyProductInfo
      const qrData = bugGooodsInfo?.qrData || {}
      let data = {}
      if (queryFrom === 'ewShopDetail' || queryFrom === 'ewShoppingCarList') {
        const salesRemark = getEWRemark()
        const productInfo = state.cartData[0].list[0]
        const carInfo = productInfo.carInfo

        data = {
          carInfo: {
            warrantyExpirationDate: productInfo.warrantyExpirationDate,
            evaFirstRegistrationDate: productInfo.firstRegistrationDate,
            threeGuaranteesDate: productInfo.threeGuaranteesDate,
            vin: carInfo.vin,
            fin: carInfo.fin
          },
          customerInfo: {
            givenName: state.name,
            mobile: state.mobile
          },
          gsCode: bugGooodsInfo.shopData.product.gsCode,
          orderAmount: state.orderAmount,
          productInfo: {
            categoryId: state.categoryId,
            productId: productInfo.productId,
            mobileCartItemId: bugGooodsInfo?.cartId ? _.toNumber(bugGooodsInfo?.cartId) : undefined
          },
          salesChannel: 'WECHAT',
          salesRemark,
          orderType: 'EW'
        }
      } else {
        data = {
          typeFlag,
          contactMobile: state.mobile,
          contactName: state.name,
          salesChannel: qrData?.salesChannel || '',
          firstRegistrationDate: qrData?.firstRegistrationDate || '',
          currentMile: qrData?.currentMile || '',
          roleCode: qrData?.roleCode || '',
          roleName: qrData?.roleName || '',
          d8Account: qrData?.d8Account || '',
          salesName: qrData?.salesName || ''
        }
      }

      // 来自商品详情
      if (queryFrom === 'shopDetail' || queryFrom === 'shoppingCarList') {
        let typeIndex = 0
        let list = state.cartData[typeIndex]?.list.map((item, itemIndex) => {
          let key = `${typeIndex}-${itemIndex}-${item.productId}`
          let customerRemark = state.markData[key] || ''
          return {
            productAmount: item.productAmount,
            productId: item.productId,
            productType: item.productType,
            gsCode: item.gsCode,
            customerCarId: item.customerCarId,
            customerRemark,
            cartId: item?.cartId,
            firstRegistrationDate: item?.firstRegistrationDate
          }
        })
        data.productInfo = list
      }
      return { ...data }
    }

    // 提交订单数据
    const subOrder = _.debounce(async () => {
      // console.log('subOrder---', state.isAgree, state.subIng)
      if (!state.isAgree || state.subIng) return
      if (!state.name) {
        showToast('联系人姓名缺失，请完善联系人信息')
        return
      }
      if (!state.mobile) {
        showToast('联系人电话缺失，请完善联系人信息')
        return
      }
      // otr扫码有订单号
      const bugGooodsInfo = store.state.currentBuyProductInfo
      const shopData = bugGooodsInfo?.shopData
      if (shopData && shopData.orderNo) {
        try {
          if (state.queryFrom === 'ewShopDetail') {
            const params = {
              givenName: state.name,
              mobile: state.mobile,
              orderNo: shopData.orderNo,
              remark: getEWRemark()
            }
            await bindOTROrder(params)
          } else {
            const params = { orderNo: shopData.orderNo, contactMobile: state.mobile, contactName: state.name }
            await bindOrderForCustomer(params)
          }
        } catch (error) {
          showToast(error.message)
          return
        }
      }
      state.subIng = true
      let param = getSubParam()
      if (!param) return
      state.isShowLoad = true
      try {
        let res = null
        if (!shopData?.orderNo) {
          res = await shopCreateOrder(param)
        }
        state.isShowLoad = false
        state.subIng = false
        state.orderNo = res?.orderNo || shopData?.orderNo
        store.dispatch('getCountOfShoppingCar')
        setSession('shopSelectedCoupon', {})
        setSession('shopMarkData', {})
        // 0元订单，直接进入待完成状态，潘静又又改需求了，要跳转到订单列表页面
        if (res?.orderStatusFlag === 3 || state.payAmount == 0) {
          router.replace({ path: '/orderList', query: { status: 2 } })
          return
        }
        nextTick(() => {
          showSubmitOrderPopUp.value.chosePayType({ orderNo: res?.orderNo || shopData?.orderNo, orderTypeFlag: state.orderTypeFlag })
        })
      } catch (e) {
        Toast({ message: e.message || '订单提交失败', position: 'bottom' })
        state.subIng = false
        state.isShowLoad = false
      }
    }, 300)

    onMounted(async () => {
      state.selectedCoupon = getSession('shopSelectedCoupon') || {}
      state.markData = getSession('shopMarkData') || {}
      state.queryFrom = route.query.from
      state.orderNo = ''
      getPageDataFn()
    })
    return {
      ...toRefs(state),
      subOrder,
      showSubmitOrderPopUp,
      // isAgree,
      changeMark,
      changeDiscount,
      toContactsList,
      viewContract,
      showPopUp,
      contractData,
      showUserPopUp,
      checkboxGroupRef,
      changeAll,
      severPactionListData
    }
  }
}
</script>

<style lang="scss" scoped>
.confirmOrderPage {
  background-color: #f5f5f5;
  color: #666666;
  font-size: 12px;
  :deep(.van-checkbox__icon) {
    font-size: 14px;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.contentWrap {
  margin: 10px 0 80px;
  text-align: left;
  margin-bottom: calc(constant(safe-area-inset-bottom) + 100px);
  margin-bottom: calc(env(safe-area-inset-bottom) + 100px);
}
.cardBox {
  background-color: #fff;
  margin-bottom: 10px;
}

.orderIfnRow {
  padding: 10px 10px 10px;
  border-bottom: 1px solid #ccc;
}
.orderItemBox:last-child .orderIfnRow {
  border-bottom: none;
}
.bottomWrap {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 74px;
  background-color: #fff;
  // line-height: 48px;
  font-weight: 600;
  font-size: 14px;
  color: #666;
  z-index: 200;
  vertical-align: middle;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  // calc(constant(safe-area-inset-bottom) + 100px)
}
.priceBox {
  padding: 10px 10px 10px 18px;
  height: 74px;
  box-sizing: border-box;
}
.sub {
  height: 74px;
  color: #fff;
  line-height: 74px;
  background-color: #3088c5;
}
.disableBtn {
  opacity: 0.4;
}
.titleBox {
  margin: 0 10px;
  padding: 0 10px;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
}
.titleRow {
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  color: #333;
  vertical-align: middle;
  .title {
    font-weight: 600;
  }
}
.iconImg {
  width: 18px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
}
.agreeBox {
  padding: 10px 20px;
  line-height: 24px;
  font-size: 12px;
  background-color: #fff;
  color: #333;
  .checkboxSpan {
    padding-right: 10px;
    width: 16px !important;
  }
}
.severPactionItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.severPaction {
  color: #3088c5;
  text-decoration: underline;
  text-decoration-color: #3088c5;
}
.price {
  font-weight: 600;
  font-size: 16px;
  color: #3088c5;
}
</style>
